module.exports = __webpack_public_path__ + "static/media/jen-site.a81c389d.jpg";